import { styled, css } from 'styled-components';
import { motion } from 'framer-motion';

interface Props {
  $useBackground?: boolean;
}

export const Container = styled(motion.div)<Props>`
  ${({ theme: { colors }, $useBackground = true }) => css`
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1046;
    cursor: auto;
    ${
      $useBackground &&
      css`
        background: ${colors.brandDarkAlpha90};
      `
    }
  `}
`;
